export const classes = {
  wrapper: 'rounded-full',
};

export const styles = {
  wrapper: (diameter: number) => ({
    height: `${diameter}px`,
    width: `${diameter}px`,
  }),
};
